/** @format */
import { Button } from '@mpb-com/feather/components/atoms/button';
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import {
    HeadingSize,
    HighlightColor,
} from '@mpb-com/feather/components/atoms/heading/types';
import { Trans, useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { styles } from './join-now-tile.styles';
import { JoinNowTileProps } from './types';

const StyledJoinNowTile = styled.div`
    ${styles}
`;

export const JoinNowTile: FunctionComponent<JoinNowTileProps> = ({
    openModal,
}) => {
    const { t } = useTranslation();

    return (
        <StyledJoinNowTile className="join-now">
            <Heading
                className="join-now-heading"
                size={HeadingSize.H3}
                highlightColor={HighlightColor.TEXT_ACCENT_INVERSE}
            >
                <Trans
                    components={{
                        'bold-text': <strong key={0}>$1</strong>,
                    }}
                >
                    {t('Get more from <bold-text>MPB</bold-text>')}
                </Trans>
            </Heading>
            <p className="join-now-content">
                {t(
                    'Sign up for a free MPB account with more features. It’s now even faster to buy, sell and trade in your camera gear. Plus, you’ll get access to exclusive offers, creative news and original content. '
                )}
            </p>
            <Button className="join-now-button" onClick={openModal}>
                {t('Join now')}
            </Button>
        </StyledJoinNowTile>
    );
};
